import React from 'react';
import classnames from 'classnames';
import MulSelector, { renderImgText } from './MultipleSelector';
import { Bubble } from 'tea-component'; // Select
import Selects from './SelectSource';
import { useIntl, history } from 'umi';
import { useFilterOptionList } from '@/pages/intelligence/hooks/useFilterOptionList';

export default function AnnieSource(props: any) {
  const {
    className,
    onConfirm,
    value = [],
    showDatabrain,
    type = 'multiple' /** single */,
    isSearchItemMargin = false,
    title,
    options,
    ...rest
  } = props;
  const { formatMessage } = useIntl(); // 中英切换方法

  // console.log('AnnieSource', props);

  const { dataSourceFilterOptions, dataSourceFilterOptionsAll } = useFilterOptionList({
    formatMessage,
  });
  const handleClickLearnMore = (tipMetrics: string) => {
    history.push({
      pathname: '/intelligence/sourcesMetrics/sources',
      query: {
        sourceValue: 'Sparkers(GSD)',
        scroll: tipMetrics,
      },
    });
  };
  const renderOptions = (showDatabrain: boolean) => {
    const optionsList =
      options?.length > 0
        ? options
        : showDatabrain
        ? dataSourceFilterOptionsAll
        : dataSourceFilterOptions;

    return optionsList?.map((item, idx) => ({
      value: item?.value,
      text: (
        <>
          <Bubble
            dark
            content={
              typeof item.tip === 'string' ? (
                <span
                  style={{
                    display: 'inline-block',
                    width: '101%',
                    height: '100%',
                  }}
                >
                  <span>{formatMessage({ id: item.tip })}</span>
                  <div>
                    {item.tipMetrics && (
                      <span
                        onClick={() => handleClickLearnMore(item.tipMetrics)}
                        className="dbi-common-chart-link"
                      >
                        {formatMessage({ id: 'dbl_home_getting_start_learn' })}
                      </span>
                    )}
                  </div>
                </span>
              ) : (
                item.tip
              )
            }
          >
            <span style={{ display: 'inline-block', width: '100%', height: '100%' }}>
              {renderImgText(item?.text, item?.img)}
            </span>
          </Bubble>
        </>
      ),
      buttonText: renderImgText(item?.text, item?.img), // button展示不Hover
    }));
  };

  function sortArrayByArray(arrayToSort: string[], sortingArray: string[]) {
    return arrayToSort?.sort((a, b) => {
      return sortingArray.indexOf(a) - sortingArray.indexOf(b);
    });
  }

  const handleChange = (values: string[] | string) => {
    if (onConfirm instanceof Function) {
      if (Array.isArray(values)) {
        // 添加数据源按列表排序
        const sortingArray = dataSourceFilterOptionsAll?.map((t) => t?.value);
        const sortValues = sortArrayByArray(values, sortingArray);
        onConfirm(sortValues);
      } else {
        onConfirm(values);
      }
    }
  };

  return type === 'single' ? (
    <>
      <Selects
        {...rest}
        className={classnames('select-item', className)}
        appearance="button"
        matchButtonWidth
        options={renderOptions(showDatabrain)}
        value={Array.isArray(value) ? value[0] : value}
        onChange={handleChange}
        size="m"
        button={(item: any) => {
          if (item?.buttonText) {
            return item?.buttonText;
          }
        }}
        buttonName={formatMessage({ id: title ? title : 'dbi_source' })}
      />
    </>
  ) : (
    <MulSelector
      className={classnames('', className)}
      value={typeof value === 'string' ? [] : value}
      options={renderOptions(showDatabrain)}
      buttonName={formatMessage({ id: 'dbi_source' })}
      onChange={handleChange}
    />
  );
}
